import { Component, Input } from '@angular/core';
import {
  HireItemAttachment,
  HireItemAttachmentStage
} from '../../../../models/HireItemAttachment';
import { HireItemListStoreService } from '../hire-item-list-store.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../dialogs/confirm-dialog/confirm-dialog.component';
import { ConfigService } from '../../../services/config.service';
import { FileSizePipe } from '../../../pipes/file-size.pipe';
import { MomentModule } from 'ngx-moment';
import { HireItemAttachmentStagePipe } from '../../../pipes/hire-item-attachment-stage.pipe';
import { UserIdToNamePipe } from '../../../pipes/user-id-to-name.pipe';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { NgFor, NgIf, AsyncPipe } from '@angular/common';

const stageOrder = [
  'delivery',
  'on_hire',
  'during_hire',
  'off_hire',
  'collection'
];

interface GroupedAttachments {
  setId: string;
  stage: HireItemAttachmentStage;
  attachments: HireItemAttachment[];
  user_id: number;
  description: string | null;
  date: string;
}

@Component({
    selector: 'app-hire-item-attachment-list',
    templateUrl: './hire-item-attachment-list.component.html',
    providers: [FileSizePipe],
    styles: [
        `
      .attachment-item mat-icon {
        visibility: hidden;
      }

      .attachment-item:hover mat-icon {
        visibility: visible;
      }
    `
    ],
    standalone: true,
    imports: [NgFor, MatIcon, MatTooltip, NgIf, AsyncPipe, UserIdToNamePipe, HireItemAttachmentStagePipe, MomentModule]
})
export class HireItemAttachmentListComponent {
  @Input() set attachments(value: HireItemAttachment[]) {
    this.attachmentGroups = value
      .reduce((acc, attachment) => {
        const setId = attachment.set;
        const stage = attachment.stage;
        const date = attachment.created_at;
        const user_id = attachment.uploaded_by;
        const description = attachment.description;
        const existingSet = acc.find(
          (item) => item.setId === setId && item.stage === stage
        );
        if (existingSet) {
          existingSet.attachments.push(attachment);
        } else {
          acc.push({
            setId,
            stage,
            attachments: [attachment],
            date,
            user_id,
            description
          });
        }
        return acc;
      }, [])
      .sort(
        ({ date: a, date: b }) => new Date(b).getTime() - new Date(a).getTime()
      )
      .sort((a, b) => {
        return stageOrder.indexOf(a.stage) - stageOrder.indexOf(b.stage);
      });
  }

  attachmentGroups: GroupedAttachments[] = [];
  dateFormat = ConfigService.dates.shortDateTimeFormat;

  constructor(
    private hireItemListStore: HireItemListStoreService,
    private dialog: MatDialog
  ) {}

  deleteAttachment(hireItemId: number, id: number) {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Delete Attachment',
          message: 'Are you sure you want to delete this attachment?',
          type: 'delete'
        }
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.hireItemListStore.deleteAttachment({ hireItemId, id });
        }
      });
  }

  downloadAttachment(attachment: HireItemAttachment) {
    this.hireItemListStore.download(attachment);
  }
}
